import { createContext } from 'react';

const LiveOrderContext = createContext(); // create context for chat app

export default LiveOrderContext;